export default __webpack_public_path__ + "static/media/hotelBook2.de45b996.jpg";